import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language';
import Links from './Links';
import Profile from './Profile';

const Header = () => {
    const { dictionary: { navigation } } = useContext(LanguageContext);

    return (
        <header className="header">
            <Profile />
            <Links items={navigation} />
        </header>
    )
}

export default Header